import React, { useId } from 'react';
import clsx from 'clsx';

const inputClass =
  'w-full bg-ninja-gray/50 dark:bg-[#111] border border-border rounded-xl px-4 py-2.5 text-sm text-ninja-dark dark:text-white outline-none focus:border-ninja-green transition-colors disabled:opacity-60';

/**
 * Stand-in for the MUI `TextField` the legacy forms were written with: label,
 * input, optional helper line and an optional control at the end of the input.
 *
 * @param {object} props
 * @param {string} [props.label]
 * @param {string} [props.helperText]
 * @param {boolean} [props.error]
 * @param {React.ReactNode} [props.endAdornment]
 */
const TextField = ({ label, helperText, error, endAdornment, className, id, ...inputProps }) => {
  const generatedId = useId();
  const inputId = id || generatedId;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-semibold text-ninja-dark dark:text-white mb-1.5">
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        <input
          id={inputId}
          {...inputProps}
          className={clsx(inputClass, endAdornment && 'pr-12', error && 'border-danger')}
        />
        {endAdornment && <div className="absolute right-2 flex items-center">{endAdornment}</div>}
      </div>
      {helperText && <p className="text-xs text-text-muted mt-1">{helperText}</p>}
    </div>
  );
};

export default TextField;
